import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit {
  public loaded:boolean=false;
  public documents:Document[];
  public courseId;
  fileData: File = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  newFileType:string;
  newFileB64:string;
  newFileName:string;
  @ViewChild('fileInput', {static: false}) fileInput: ElementRef;

  constructor(
    private _course: CourseService,
    private _route: ActivatedRoute,
    private _notify: NotificationService
  ) {
    this.courseId=this._route.snapshot.paramMap.get('courseId');
  }

  getDocuments(){
    this._course.getDocuments(this.courseId).subscribe(
      res=>{
        this.documents=res;
        this.loaded=true;
      }
    );
  }

  fileProgress(evt: any) {
    var files = evt.target.files;
    var file = files[0];
    if (files && file) {
      this.newFileType=file.type;
      this.newFileName=file.name;
      var reader = new FileReader();
      reader.onload =this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  private _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.newFileB64= btoa(binaryString);
  }

  public resetUploader(){
    this.newFileB64='';
    this.newFileType='';
    this.fileInput.nativeElement.value = "";
  }

  public uploadNewDocument(){
    this._course.uploadDocument(this.newFileName, this.newFileType, this.newFileB64, this.courseId).subscribe(
      res=>{
        this.resetUploader();
        this.getDocuments();
      }
    );
  }

  public deleteDocument(docId:number){
    if(!confirm('Confirm deletion of this document.')) return false;
    this._course.deleteDocument(docId, this.courseId).subscribe(
      res=>{
        this.getDocuments();
      }
    );
  }

  ngOnInit() {
    this.getDocuments();
  }

}
